"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import React from "react";
import { observer } from "mobx-react";
import { CSSTransition } from "react-transition-group";
import { AnimationDuration } from "../../../styles/Animations";
import { Tick, IconSize } from "../../icons";
import { KeyType } from "../../../utils";
export var CheckboxTheme = /* @__PURE__ */ ((CheckboxTheme2) => {
  CheckboxTheme2["Light"] = "light";
  CheckboxTheme2["Dark"] = "dark";
  return CheckboxTheme2;
})(CheckboxTheme || {});
export var CheckboxSize = /* @__PURE__ */ ((CheckboxSize2) => {
  CheckboxSize2["Small"] = "small";
  CheckboxSize2["Medium"] = "medium";
  CheckboxSize2["Large"] = "large";
  return CheckboxSize2;
})(CheckboxSize || {});
let Checkbox = class extends React.Component {
  constructor() {
    super(...arguments);
    this.renderLabel = () => {
      const { theme, item, isDisabled, labelHidden } = this.props;
      const checkboxLabelClasses = classNames(["checkbox-component__label", `checkbox-component__label--${theme}`], {
        "checkbox-component__label--is-disabled": isDisabled,
        "checkbox-component__label--hidden": labelHidden
      });
      return /* @__PURE__ */ React.createElement("label", { htmlFor: `checkbox-${item.id}`, className: checkboxLabelClasses, id: `checkbox-${item.id}-label` }, item.label);
    };
    this.handleKeydown = (event) => {
      if (event.key === KeyType.Space) {
        event.preventDefault();
        this.handleChange(event);
      }
    };
    this.handleChange = (event) => {
      if (!this.props.isDisabled) {
        this.props.onChange(this.props.toggleKey || "", event);
      }
    };
  }
  render() {
    var _a, _b, _c, _d;
    const { size, theme, item, isSelected, isDisabled, labelHidden, role } = this.props;
    const checkBoxClickFieldClasses = classNames({
      "checkbox-component__click-field": true,
      "checkbox-component__click-field--without-label": labelHidden,
      "checkbox-component__click-field--is-disabled": isDisabled
    });
    const checkboxBoxClasses = classNames([`checkbox-component__box--${theme}`, `checkbox-component__box--${size}`], {
      "checkbox-component__box": true,
      "checkbox-component__box--is-selected": isSelected,
      "checkbox-component__box--is-disabled": isDisabled
    });
    return /* @__PURE__ */ React.createElement("div", { className: `checkbox-component checkbox-${item.id}` }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: checkBoxClickFieldClasses,
        onClick: this.handleChange,
        onKeyDown: this.handleKeydown,
        role: role != null ? role : "checkbox",
        "aria-labelledby": `checkbox-${item.id}-label`,
        "aria-checked": isSelected,
        "aria-disabled": isDisabled,
        tabIndex: isDisabled ? -1 : 0,
        onFocus: (_b = (_a = this.props).onFocus) == null ? void 0 : _b.call(_a),
        onBlur: (_d = (_c = this.props).onBlur) == null ? void 0 : _d.call(_c)
      },
      /* @__PURE__ */ React.createElement("div", { className: checkboxBoxClasses, id: item.id }, /* @__PURE__ */ React.createElement(
        CSSTransition,
        {
          mountOnEnter: true,
          unmountOnExit: true,
          in: isSelected,
          timeout: AnimationDuration.Medium,
          classNames: "checkbox-component__box-actions-"
        },
        /* @__PURE__ */ React.createElement(Tick, { size: IconSize.Small, className: "checkbox-component__tick" })
      )),
      this.renderLabel()
    ));
  }
};
Checkbox.defaultProps = {
  isDisabled: false,
  theme: "light" /* Light */,
  size: "small" /* Small */
};
Checkbox = __decorateClass([
  observer
], Checkbox);
export {
  Checkbox as default
};
